import { renderToStaticMarkup } from "react-dom/server";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { createElement } from "react";

const EXPORT_ICON_SVG = renderToStaticMarkup(
  createElement(FileDownloadIcon, { style: { width: 19, height: 19 } })
);

const EXPORT_FORMATS = [
  { value: "geojson", label: "GeoJSON" },
  { value: "kml", label: "KML" },
  { value: "shp", label: "Shapefile" },
];

export const addExportContourButton = ({ mapRef, drawRef, onExport }) => {
  const drawGroup = Array.from(
    document.querySelectorAll(".mapboxgl-ctrl-group"),
  ).find((group) => group.querySelector(".mapbox-gl-draw_polygon"));

  if (!drawGroup) return null;
  if (drawGroup.querySelector(".mapbox-gl-draw_export")) return null;

  const button = document.createElement("button");
  button.className = "mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_export";
  button.title = "Exporter un contour";
  button.type = "button";
  button.setAttribute("data-testid", "draw-export-button");
  button.setAttribute("data-tooltip", "Exporter un contour");
  button.style.display = "flex";
  button.style.alignItems = "center";
  button.style.justifyContent = "center";
  button.innerHTML = EXPORT_ICON_SVG;

  // ── Dropdown menu ──
  const menu = document.createElement("div");
  menu.className = "draw-export-menu";
  menu.setAttribute("data-testid", "draw-export-menu");
  menu.style.display = "none";
  menu.style.position = "fixed";
  menu.style.borderRadius = "8px";
  menu.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
  menu.style.zIndex = "2000";
  menu.style.minWidth = "130px";
  menu.style.overflow = "hidden";
  // REMOVE: menu.style.background / menu.style.border / menu.style.color

  const positionMenu = () => {
    const rect = button.getBoundingClientRect();
    const menuRect = menu.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const gap = 4;

    let left = rect.left - menuRect.width - gap;
    if (left < gap) {
      left = rect.right + gap;
      if (left + menuRect.width > viewportWidth - gap) {
        left = viewportWidth - menuRect.width - gap;
      }
    }

    let top = rect.top;
    if (top + menuRect.height > viewportHeight - gap) {
      top = rect.bottom - menuRect.height;
    }
    if (top < gap) top = gap;

    menu.style.left = `${left}px`;
    menu.style.top = `${top}px`;
  };

  const closeMenu = () => {
    menu.style.display = "none";
    document.removeEventListener("click", handleOutsideClick, true);
    window.removeEventListener("resize", positionMenu);
    window.removeEventListener("scroll", positionMenu, true);
  };

  const openMenu = () => {
    menu.style.display = "block";
    positionMenu();
    document.addEventListener("click", handleOutsideClick, true);
    window.addEventListener("resize", positionMenu);
    window.addEventListener("scroll", positionMenu, true);
  };

  const handleOutsideClick = (e) => {
    if (!menu.contains(e.target) && e.target !== button) {
      closeMenu();
    }
  };

  EXPORT_FORMATS.forEach(({ value, label }) => {
    const item = document.createElement("button");
    item.type = "button";
    item.textContent = label;
    item.className = "draw-export-option";        // ← added for CSS hover
    item.setAttribute("data-testid", `draw-export-option-${value}`);
    item.style.display = "block";
    item.style.width = "100%";
    item.style.padding = "8px 12px";
    item.style.border = "none";
    item.style.background = "none";
    item.style.textAlign = "left";
    item.style.cursor = "pointer";
    item.style.fontSize = "13px";

    // REMOVE inline mouseenter / mouseleave background changes
    // REMOVE item.style.color

    item.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
      onExport?.(value);
    });

    menu.appendChild(item);
  });

  button.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (menu.style.display === "block") {
      closeMenu();
    } else {
      openMenu();
    }
  });

  drawGroup.appendChild(button);

  // ── Append inside .app-view so it inherits theme CSS variables ──
  const appView = document.querySelector(".app-view");
  (appView || document.body).appendChild(menu);

  return { button, menu };
};